import useMessaging from '@/modules/message/useMessaging'

function reportError(message: string): void {
  useMessaging().addError(message)
}

function reportErrorMessage(message: string): void {
  useMessaging().addError(message)
}

function reportRefreshError(message: string): void {
  useMessaging().addError(message, undefined, true)
}

function reportSuccess(message: string, link?: string): void {
  useMessaging().addSuccess(message, link)
}

function reportSuccessMessage(message: string, link?: string): void {
  useMessaging().addSuccess(message, link)
}

function reportWarning(message: string): void {
  useMessaging().addWarning(message)
}

export default {
  reportError,
  reportErrorMessage,
  reportSuccess,
  reportSuccessMessage,
  reportRefreshError,
  reportWarning
}
